// Voice editor — 1. Identity section. Extracted verbatim from
// `VoiceEditorPage.tsx` (no behavior change).

import { useT } from '@barel/i18n';
import { FieldAssembly, Segmented } from '@barel/ui';

import { SectionShell, type SectionPropsWithVoice } from './SectionShell';

export function IdentitySection({ voice, flush }: SectionPropsWithVoice) {
  const t = useT('voice');
  return (
    <SectionShell id="voice-identity" title={t('identity.title')} subtitle={t('identity.subtitle')}>
      <div className="flex flex-col gap-4">
        <FieldAssembly
          label={t('identity.languageLabel')}
          description={t('identity.languageSub')}
          asChild
        >
          <div role="group" aria-label={t('identity.languageLabel')}>
            <Segmented<'fr' | 'en' | 'mirror'>
              value={voice.language}
              onValueChange={(next) => {
                void flush({ language: next });
              }}
              options={[
                { value: 'fr', label: t('identity.languageFr') },
                { value: 'en', label: t('identity.languageEn') },
                { value: 'mirror', label: t('identity.languageMirror') },
              ]}
              aria-label={t('identity.languageLabel')}
              size="sm"
            />
          </div>
        </FieldAssembly>
        <FieldAssembly
          label={t('identity.formalityLabel')}
          description={t('identity.formalitySub')}
          asChild
        >
          <div role="group" aria-label={t('identity.formalityLabel')}>
            <Segmented<'vous' | 'tu' | 'mirror'>
              value={voice.formality}
              onValueChange={(next) => {
                void flush({ formality: next });
              }}
              options={[
                { value: 'vous', label: t('identity.formalityVous') },
                { value: 'tu', label: t('identity.formalityTu') },
                { value: 'mirror', label: t('identity.formalityMirror') },
              ]}
              aria-label={t('identity.formalityLabel')}
              size="sm"
            />
          </div>
        </FieldAssembly>
      </div>
    </SectionShell>
  );
}
